
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-wash/[city]",
      function () {
        return require("private-next-pages/car-wash/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-wash/[city]"])
      });
    }
  